import React, { useState } from 'react';
import { urls } from '..';
import { usePrematchData } from '../prematch/PrematchDataProvider';
import { getTorneiInEvidenza } from '../data/utils/getTorneiInEvidenza';
import { removeMultipleSlashes } from '../data/sport-utils';
import { getLabel } from '../data/labels';
import { useIsDateSection } from './IsDateSectionProvider';
import useIsLiveSection from './useIsLiveSection';
import XRouterLink from './seo/xrouter/XRouterLink';
import TournamentCheckbox from './TournamentCheckbox';

function PopularTournamentRow({ tournament, categoryIcon }) {
    const url = removeMultipleSlashes(
        `${urls.base}/${urls.prematch.base}/${urls.prematch.tournament}/${tournament.uniqueId}`
    );
    return (
        <div className="xs_tournamentItem h-[40px] grid grid-cols-10 items-center bg-cs1 border-b border-b-cs7">
            <div className={'col-start-1 col-end-2 justify-self-center inline-block w-[16px] h-[16px] ' +
                (categoryIcon || '')
            } />
            <XRouterLink
                to={url}
                data={tournament}
                state={tournament}
                className="col-start-2 col-end-9 px-1 flex items-center truncate" >
                <span className="font-bold text-sm text-cs10 truncate">
                    {tournament.descrizione}
                </span>
            </XRouterLink>
            <div className="col-start-9 col-end-10 flex items-center justify-center">
                <TournamentCheckbox id={tournament.uniqueId} />
            </div>
            <div className="col-start-10 col-end-11 flex items-center justify-center">
                <div className="min-h-[20px] min-w-[28px] w-fit px-1 flex items-center justify-center bg-cs4 rounded-md">
                    <span className="leading-[.6rem] font-medium text-xxs text-cs1">
                        {tournament.eventsCount}
                    </span>
                </div>
            </div>
        </div>
    );
}

export default function PopularTournaments({ sportId }) {
    const isDateSection = useIsDateSection();
    const isLiveSection = useIsLiveSection();
    const prematchData = usePrematchData();
    const [toggled, setToggled] = useState(true);

    if (isDateSection || isLiveSection) return null;

    let sports = prematchData.sport;
    let sport = null;
    if (sportId != null) {
        sport = prematchData.sportById[sportId];
        sports = sport ? [sport] : sports;
    }

    const items = [];
    const data = getTorneiInEvidenza(sports, 'ALL');
    const tournaments = data.tournamentsList;
    if (tournaments.length > 0) {
        // Mappo categoryRef - categoryIcon così possiamo iterare i tornei
        // nell'ordine puro del ranking CMS senza raggrupparli per categoria.
        const categoryIconByRef = new Map();
        (data.sportsList[0]?.categories || []).forEach(c => {
            categoryIconByRef.set(c.id, c.categoryIcon);
        });

        // tournamentsList è già ordinato per ranking (byTournamentsRanking),
        // che riflette l'ordine di conf.tie impostato a CMS
        tournaments.forEach(t => {
            items.push(
                <PopularTournamentRow
                    key={`t-${t.uniqueId}`}
                    tournament={t}
                    categoryIcon={categoryIconByRef.get(t.categoryRef)}
                />
            );
        });
    }

    if (items.length === 0) return null;

    return (
        <>
            <div className="xs_categoryHeader grid grid-cols-10 py-1 bg-cs7 text-cs6 border border-b border-b-cs16"
                onClick={() => setToggled(!toggled)}>
                <div className="col-start-1 col-end-10 pl-2 flex items-center">
                    <span className="font-medium text-xs uppercase mr-auto">
                        {getLabel('popular', 'Popolari')}
                    </span>
                </div>
                <div className="col-start-10 col-end-11 flex items-center justify-center">
                    <i className={toggled ? 'bi bi-chevron-up' : 'bi bi-chevron-down'}></i>
                </div>
            </div>
            {toggled && items}
        </>
    );
}